/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * rAF 를 이용하여 DOM을 렌더링하는 클래스를 정의한다.
 *
 * @file /src/utils/Renderer.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 8. 17.
 */
import { AnimationFrames } from '@utils/AnimationFrames';
export class Renderer {
    private static queue = new Set<() => Promise<void>>();
    private static rAFId: string = null;
    private static readonly FRAME_BUDGET = 200;

    /**
     * 싱글톤방식을 사용하기 위해 constructor 를 private 로 생성한다.
     */
    private constructor() {}

    /**
     * 렌더링 작업을 요청한다.
     *
     * @param job - 렌더링함수
     */
    static request(job: () => Promise<void>): Promise<void> {
        return new Promise((resolve, reject) => {
            this.queue.add(async () => {
                try {
                    await job();
                    resolve();
                } catch (e) {
                    reject(e);
                }
            });

            if (this.rAFId === null || AnimationFrames.isActive(this.rAFId) == false) {
                this.rAFId = AnimationFrames.request(this.tick, 'Renderer', this);
            }
        });
    }

    /**
     * rAF 프레임당 처리할 수 있는 수준까지 렌더링을 처리한다.
     */
    private static tick(frameStart: DOMHighResTimeStamp): boolean {
        const deadline = frameStart + this.FRAME_BUDGET;

        const jobs = Array.from(this.queue);
        for (const job of jobs) {
            if (performance.now() > deadline) break;
            this.queue.delete(job);
            job();
        }

        if (this.queue.size > 0) {
            return true;
        }

        AnimationFrames.cancel(this.rAFId, true);
        this.rAFId = null;
        return false;
    }
}
